module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, _vm._l((_vm.cols), function(col) {
    return _c('v-flex', {
      key: col.value,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": ""
      }
    }, [_c('v-btn', {
      staticClass: "visible-xs-only",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleCol(col)
        }
      }
    }, [(_vm.visible[col.value]) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_less")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_more")])], 1), _vm._v(" "), _c('v-subheader', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(col.text) + " days")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
      staticClass: "mr-4"
    }, [_vm._v(_vm._s(_vm.formatCurrency('ZAR', _vm.totals[col.value])))])], 1), _vm._v(" "), (_vm.visible[col.value]) ? _c('invoice-list', _vm._g({
      staticClass: "invoice-list",
      class: col.color,
      attrs: {
        "invoices": _vm.report[col.value],
        "actions": _vm.actions,
        "loading": _vm.request.loading,
        "primary-action": {
          icon: 'chevron_right',
          text: 'More'
        }
      }
    }, _vm.events)) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ab2073","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/OverdueKanban.vue
// module id = 1310
// module chunks = 9